export const enrollSteps = Object.freeze({
  FIRST_STEP: 0,
  SECOND_STEP: 1,
  THIRD_STEP: 2,
  DONE: 3
});

export const enrollStepsType = Object.freeze({
  WITH_DOCUSIGN: 0,
  NO_SIGNATURE: 1,
  WITH_ESIGN: 2
});

/**
 * Valid severity options for Express Enroll banners.
 */
export const BANNER_SEVERITIES = Object.freeze(["info", "warning", "critical"]);
